import React from 'react'
import PropTypes from 'prop-types'
import {Text} from '@salesforce/retail-react-app/app/components/shared/ui'
const StoryDescription = ({description, descriptionColor, descriptionFontFamily = 'inter'}) => {
    return (
        <Text
            color={descriptionColor}
            marginTop="20px"
            fontWeight="300"
            fontSize={{base: '14px', md: '16px'}}
            fontFamily={descriptionFontFamily}
            lineHeight="25px"
        >
            {description}
        </Text>
    )
}

StoryDescription.propTypes = {
    description: PropTypes.string,
    descriptionFontFamily: PropTypes.string,
    descriptionColor: PropTypes.string
}

export default StoryDescription
